import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from 'i18next';
import FlagFireworks from './FlagFireworks';

class ProgressBar extends Component {
  renderMilestone() {
    if (!this.props.milestone) return null;

    return (
      <div className="milestone">
        <div
          className={classNames({
            'milestone-icon': true,
            'milestone-icon--hidden': !this.props.milestoneText,
          })}
        >
          <FlagFireworks
            secondary={this.props.tenant.secondary}
            primary={this.props.tenant.primary}
          />
        </div>
        <p className="milestone-text">{this.props.milestoneText}</p>
      </div>
    );
  }

  renderText(display) {
    if (!this.props.currentPhaseText) return null;

    return <p className="bar-text">{display && this.props.currentPhaseText}</p>;
  }

  getProgressLabelFromProgressVal = (progressVal) => {
    let progressLabel = '';
    if (progressVal === 100) {
      progressLabel = 'Complete';
    } else if (progressVal === 0) {
      progressLabel = 'Not yet started';
    } else if (progressVal > 0 && progressVal < 100) {
      progressLabel = 'In progress';
    }
    return progressLabel;
  };

  render() {
    const { bars, currentPhase } = this.props; // progress "bars" for different phases, "currentPhase" for current phase
    const barArray =
      bars &&
      Object.keys(bars).map((key) => {
        let width = bars[key].override ? currentPhase : bars[key].current; // use currentPhase prop if this phase is still in progress, otherise use 0 or 100 from "current" prop

        if (width < 4 && width !== 0) {
          width = 4; // ignore tiny pixel width for bar progress as a styling fix
        }
        return (
          <div className="bar-container" key={key}>
            {this.renderText(bars[key].override)}
            <div className="bar">
              <div
                className="bar-fill"
                role="img"
                aria-label={`${key} Progress: ${this.getProgressLabelFromProgressVal(
                  bars[key].override ? currentPhase : bars[key].current
                )}`}
                style={{
                  width: `${width}%`,
                  backgroundColor: this.props.tenant.secondary,
                }}
              />
            </div>
            <p
              className={classNames({
                'bar-title': true,
                current: bars[key].currentPhase,
              })}
            >
              {t(key)}
            </p>
          </div>
        );
      });

    return (
      <div
        id="progress-bar"
        className={classNames({
          [this.props.className]: this.props.className,
        })}
      >
        {this.props.children}
        {this.renderMilestone()}
        <div className="bars">{barArray}</div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  bars: PropTypes.object.isRequired,
  currentPhase: PropTypes.number,
  milestone: PropTypes.bool,
  milestoneText: PropTypes.string,
  tenant: PropTypes.object.isRequired,
};

export default ProgressBar;
